import orExpression from './orExpression';
export default (condition, items, solution) => {
  return orExpression(condition, items, solution);
};